"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AccountNavbar;
const React = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const constants_1 = require("core/constants");
function AccountNavbar({ hasTeams, children }) {
    return (React.createElement("div", { className: "u-padMd u-sm-padLg", "data-testid": "account-navbar" },
        React.createElement("h2", { className: "u-textCenter", "data-testid": "myAccountHeader" }, "My Account"),
        React.createElement("div", { className: "u-textCenter" },
            React.createElement("div", { className: "ButtonGroup u-hidden u-sm-inlineBlock", "data-testid": "mainTab" },
                React.createElement(react_router_dom_1.NavLink, { to: "/settings", activeClassName: "is-active", className: "Button" },
                    React.createElement("span", { "data-testid": "accountsSettingTab" }, "Account Settings")),
                hasTeams && (React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=teams', className: "Button", "data-testid": "manageMyTeamsTab" },
                    React.createElement("span", null, "Manage My Teams"))),
                React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=billing', className: "Button", "data-testid": "teamBillingPlansTab" },
                    React.createElement("span", null, "Team Billing & Plans")),
                React.createElement(react_router_dom_1.NavLink, { to: "/orders", activeClassName: "is-active", className: "Button" },
                    React.createElement("span", { "data-testid": "ordersTab" }, "Orders")),
                React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=clubs', className: "Button", "data-testid": "clubAndLeaguePlansTab" },
                    React.createElement("span", null, "Club & League Plans"))),
            React.createElement("div", { className: "ButtonGroup u-inlineBlock u-sm-hidden" },
                React.createElement(react_router_dom_1.NavLink, { to: "/settings", activeClassName: "is-active", className: "Button" },
                    React.createElement("span", { "data-testid": "settingsLink" }, "Settings")),
                hasTeams && (React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=teams', className: "Button", "data-testid": "teamsLink" },
                    React.createElement("span", null, "Teams"))),
                React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=billing', className: "Button", "data-testid": "billingLink" },
                    React.createElement("span", null, "Billing")),
                React.createElement(react_router_dom_1.NavLink, { to: "/orders", activeClassName: "is-active", className: "Button" },
                    React.createElement("span", { "data-testid": "ordersLink" }, "Orders")),
                React.createElement("a", { href: constants_1.TEAMSNAP_URL + '/account?view=clubs', className: "Button", "data-testid": "club/LeagueLink" },
                    React.createElement("span", null, "Club/League")))),
        children,
        React.createElement("div", { className: "teamsnap-address u-textCenter", "data-testid": "footerAddress" },
            "Copyright \u00A9 2005\u2013",
            new Date().getFullYear(),
            " TeamSnap, Inc.")));
}
